export default __webpack_public_path__ + "static/media/228.87d969d5.jpg";